"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');






var _types = require('web/screens/Signup/types');
var _utils = require('web/screens/Signup/utils');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _noticeBar = require('web/services/context/noticeBar');
var _orgCreation = require('shared/services/orgCreation');


var _stepErrors = require('../stepErrors');



var _signupAttribution = require('web/services/signupAttribution');




var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _signupDraft = require('../signupDraft');

// Resolves true when the account exists after the call (a fresh submit, or a
// used token meaning it was already created) so callers can chain the login.




















const captureAnalytics = (capture) => {
  try {
    capture()
  } catch (err) {
    // Analytics is best-effort and must never interrupt signup.
    log.error(err instanceof Error ? err : String(err))
  }
}

















 const useSubmit = (
  token, onSubmitSetup, gotoStep, isTokenInvited, continuation, onAgreementsRejected,
  onOrgMatchesChanged, onStepError,
) => {
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [survey, setSurvey] = _react.useState()
  const [pendingMFA, setPendingMFA] = _react.useState(null)
  const pendingAuthenticatedAction = _react.useRef(undefined)
  // A phone number can be on several accounts, so a phone invitee signs in
  // with the new account's key rather than the number.
  const setupUserKey = _react.useRef(undefined)

  const finishLogin = _react.useCallback.call(void 0, 
    (
      r,
      surveyOverride,
      onAuthenticated,
    ) => {
      const submittedSurvey = _nullishCoalesce(surveyOverride, () => ( survey))
      const meta = submittedSurvey ? { survey: submittedSurvey } : undefined
      _actions2.default.loginSuccess(r, meta)

      // Trial-step callers provide the exact authenticated action. The legacy
      // classification fallback remains for retry-safe callers without one.
      // Both require exactly one org the user newly admins; zero or ambiguous
      // matches fall back to the inbox so a resolution edge never strands the
      // user. Invited/join-request signups always go to the inbox.
      if (continuation || onAuthenticated) {
        const adminOrgKeys = _onboardingAnalytics.getNonPendingAdminOrgKeys.call(void 0, _optionalChain([r, 'access', _ => _.User, 'optionalAccess', _2 => _2.Relationships]))
        const [onlyOrgKey] = adminOrgKeys
        if (adminOrgKeys.length === 1 && onlyOrgKey) {
          if (onAuthenticated) return onAuthenticated(onlyOrgKey)
          if (continuation === 'payment') _actions2.default.gotoOnboardingPayment(onlyOrgKey)
          else _actions2.default.gotoOnboardingDemo(onlyOrgKey)
          return
        }
        log.error(
          `onboarding continuation (${continuation}): expected exactly one non-pending admin org, got ${adminOrgKeys.length}; routing to inbox`,
        )
      }

      _actions2.default.gotoInbox()
    },
    [survey, continuation],
  )

  const onSubmit = _react.useCallback.call(void 0, 
    (personalInfo, password, orgs, orgSurvey, signupMFAChallengeKey, agreements) => {
      // Token-invited signups (the welcome token carried org relationships) are
      // always 'invited'. A cold signup that submits an existing-org selection is
      // a pending join request, not an invite; only all-new orgs are 'net_new'.
      const signupType = isTokenInvited
        ? 'invited'
        : orgs.some(_utils.isExistingOrgRel)
          ? 'join_request'
          : 'net_new'

      captureAnalytics(() => {
        _signupAttribution.captureSignupEvent.call(void 0, 'signup setup submitted', { signup_type: signupType })
      })
      return onSubmitSetup({
        token,
        firstName: personalInfo.firstName,
        lastName: personalInfo.lastName,
        email: personalInfo.email || '',
        phone: personalInfo.phone || '',
        password,
        orgs,
        orgSurvey,
        signupMFAChallengeKey,
        signupAttribution: _signupAttribution.getSignupSetupAttribution.call(void 0, ),
        agreements,
      })
        .then(r => {
          setupUserKey.current = _optionalChain([r, 'optionalAccess', _3 => _3.UserKey]) || undefined
          captureAnalytics(() => {
            _signupAttribution.captureSignupEvent.call(void 0, 'signup completed', { signup_type: signupType })
          })
          captureAnalytics(() => {
            _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.COMPLETED, { signup_type: signupType })
          })
          // Legacy Amplitude conversion metric, mirrored to PostHog
          // `onboarding_completed`: fires once here at signup submission for
          // every cohort (net_new, invited, join_request).
          captureAnalytics(() => {
            _amplitude2.default.logEvent('SIGN_UP_COMPLETE')
          })
          setSurvey(orgSurvey)
          // The account now exists — the pre-auth draft has served its purpose.
          // Failed submits keep it (weak password etc. return to a prefilled
          // wizard).
          _signupDraft.clearSignupDraft.call(void 0, )
        })
        .then(() => {
          // Invited / join-request flows submit before their legacy FINISH
          // screen. Net-new signups submit from TRIAL_OFFER and stay on its
          // loading/MFA surface until the authenticated action takes over.
          if (!continuation) gotoStep(_types.SetupSteps.FINISH)
          return true
        })
        .catch(err => {
          const orgCreationRefusal = _orgCreation.getOrgCreationRefusal.call(void 0, err)
          if (orgCreationRefusal) {
            showWarningBar(orgCreationRefusal)
            return false
          }
          const code = _optionalChain([err, 'optionalAccess', _4 => _4.response, 'optionalAccess', _5 => _5.Error])
          // Known errors return to the step they are about and say so there.
          const known = code ? _stepErrors.submitErrors[code] : undefined
          switch (code) {
            case "weak password":
            case "invalid phone number":
            case "unsupported region":
              if (known) _optionalChain([onStepError, 'optionalCall', _6 => _6(known.step, known.message)])
              if (known) gotoStep(known.step)
              return false
            case "Token used":
              // The account already exists (e.g. a retry after a failed
              // login) — report success so the caller can proceed to login.
              // It names no account, so a phone invitee whose first response
              // was lost has no key to sign in with.
              showWarningBar("Your account was already created.")
              return true
            case "Agreement acceptance is required":
              _optionalChain([onAgreementsRejected, 'optionalCall', _7 => _7()])
              if (known) _optionalChain([onStepError, 'optionalCall', _8 => _8(known.step, known.message)])
              gotoStep(_types.SetupSteps.LEGAL_AGREEMENTS)
              return false
            case "organization matches changed":
              if (known) _optionalChain([onStepError, 'optionalCall', _9 => _9(known.step, known.message)])
              _optionalChain([onOrgMatchesChanged, 'optionalCall', _10 => _10()])
              gotoStep(_types.SetupSteps.ORG_INFO)
              return false
            default:
              // Unknown errors stay on the step that submitted and are logged.
              log.error(err)
              _optionalChain([onStepError, 'optionalCall', _11 => _11(null, _stepErrors.GENERIC_SETUP_ERROR)])
              return false
          }
        })
    },
    [token, onSubmitSetup, gotoStep, showWarningBar, isTokenInvited, continuation, onAgreementsRejected, onOrgMatchesChanged, onStepError],
  )

  const onFinish = _react.useCallback.call(void 0, 
    async (personalInfo, password, wasInvitedByPhone, submittedSurvey, onAuthenticated) => {
      const loginCredential = wasInvitedByPhone ? setupUserKey.current : personalInfo.email
      if (!loginCredential) {
        // No key came back (the first response was lost). The phone may be on
        // another account with the same password, so it can't stand in.
        const err = new Error('phone setup returned no user key')
        _optionalChain([onStepError, 'optionalCall', _12 => _12(null, _stepErrors.PHONE_SETUP_LOGIN_ERROR)])
        log.error(err)
        throw err
      }

      pendingAuthenticatedAction.current = onAuthenticated
      return _client2.default.login(loginCredential, password, false)
        .then(r => {
          if (r.MFARequired) {
            setPendingMFA(r.MFA)
            return
          }
          pendingAuthenticatedAction.current = undefined
          return finishLogin(r, submittedSurvey, onAuthenticated)
        })
        .catch(err => {
          _optionalChain([onStepError, 'optionalCall', _13 => _13(null, _stepErrors.LOGIN_AFTER_SETUP_ERROR)])
          log.error(err)
          // Re-throw so the SMS-payment auto-finish surface can render its
          // error + Retry state. The download-screen caller (FinishSection)
          // swallows this, preserving today's behavior.
          throw err
        })
    },
    [finishLogin, onStepError],
  )

  const onMFAVerified = _react.useCallback.call(void 0, (r) => {
    const action = pendingAuthenticatedAction.current
    pendingAuthenticatedAction.current = undefined
    setPendingMFA(null)
    return finishLogin(r, undefined, action)
  }, [finishLogin])

  return { onSubmit, onFinish, onMFAVerified, pendingMFA }
}; exports.useSubmit = useSubmit
